import SellerApi from '@/api/SellerApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  CreateTeamWithMembersPayload,
  TeamWithMembers,
  teamWithMembersSchema,
} from '@valuecase/common'

const createTeam = async (team: CreateTeamWithMembersPayload) => {
  const res = await SellerApi.post<{ payload: TeamWithMembers }>(`teams`, team)
  return teamWithMembersSchema.parse(res.data.payload)
}

const useCreateTeam = () => {
  const queryClient = useQueryClient()

  return useMutation((team: CreateTeamWithMembersPayload) => createTeam(team), {
    onSuccess: () => {
      queryClient.invalidateQueries(['teams'])
    },
  })
}

export default useCreateTeam
